// utils/firestoreSubcollections.js
import {
  collection,
  getDocs,
  deleteDoc,
  writeBatch,
  doc,
  setDoc,
  query,
  limit,
} from 'firebase/firestore';
import { Timestamp } from 'firebase/firestore';

export const idFromVal = (v) =>
  String(v)
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9\-]/g, '');

export async function replaceSubcollection(
  db,
  parentPath,
  subName,
  arr,
  extra = {}
) {
  const subRef = collection(db, `${parentPath}/${subName}`);
  const snap = await getDocs(subRef);

  const desired = Array.from(new Set((arr || []).filter(Boolean)));
  const desiredIds = new Set(desired.map(idFromVal));
  const toDelete = snap.docs.filter((d) => !desiredIds.has(d.id));
  await Promise.all(toDelete.map((d) => deleteDoc(d.ref)));

  const batch = writeBatch(db);
  desired.forEach((val) => {
    const docId = idFromVal(val);
    batch.set(doc(collection(db, `${parentPath}/${subName}`), docId), {
      value: val,
      ...extra,
      updatedAt: Timestamp.now(),
    });
  });
  await batch.commit();
}

export async function readSubcollectionValues(db, parentId, subName) {
  const qs = await getDocs(
    collection(db, `marketplace/${parentId}/${subName}`)
  );
  return qs.docs.map((d) => d.data()?.value).filter(Boolean);
}

export async function writeSubsMeta(db, parentPath, subs) {
  const metaRef = doc(collection(db, `${parentPath}/_meta`), 'subs');
  await setDoc(metaRef, {
    names: Array.from(new Set(subs)),
    updatedAt: Timestamp.now(),
  });
}

export async function readSubsMetaNames(db, parentId) {
  try {
    const qs = await getDocs(collection(db, `marketplace/${parentId}/_meta`));
    const hit = qs.docs.find((d) => d.id === 'subs');
    return hit?.data()?.names || null;
  } catch {
    return null;
  }
}

export async function deleteQueryBatch(db, qRef, batchSize = 50) {
  // NOTE: caller passes a CollectionReference; we apply limit() each loop
  // Behaviour unchanged vs your version.
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const snap = await getDocs(query(qRef, limit(batchSize)));
    if (snap.empty) break;
    await Promise.all(snap.docs.map((d) => deleteDoc(d.ref)));
    if (snap.size < batchSize) break;
  }
}

export async function deleteSubcollection(db, parentId, subName) {
  const subRef = collection(db, `marketplace/${parentId}/${subName}`);
  await deleteQueryBatch(db, subRef, 50);
}
